import { render } from "./GameOver.vue?vue&type=template&id=14bbaeec&scoped=true"
import script from "./GameOver.vue?vue&type=script&lang=js"
export * from "./GameOver.vue?vue&type=script&lang=js"

import "./GameOver.vue?vue&type=style&index=0&id=14bbaeec&scoped=true&lang=css"

import exportComponent from "C:\\Assembla\\VIV0006\\root\\dev\\QuizWhiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bbaeec"]])

export default __exports__